import NameDesc from './name'

export default [NameDesc]
